// custom-script.js
// assets/custom-script.js
const colors = [
    '#08505e', // Light shade 1
    '#ffae00', // Light shade 2
    '#892d56', // Light shade 3
    '#23b5da', // Light shade 4
];



let currentColorIndex = 0;
const heroSection = document.getElementById('heroSection');
    heroSection.style.backgroundColor = colors[0];

function changeBackgroundColor() {
    heroSection.style.backgroundColor = colors[currentColorIndex];
    currentColorIndex = (currentColorIndex + 1) % colors.length;
}

setInterval(changeBackgroundColor, 5000);


const canvas = document.getElementById('canvas');
    const canvasForPrint = document.getElementById('canvasForPrint');
    const caption = {
        text : [
        'میں نے تیرا نام دل رکھ دیا۔ ❤️',
          'دل دیوانہ بن سجنا ❤️',
          'تمہارے بغیر یہ دنیا سونی ❤️',
          'تم جو آئے زندگی میں، بات بن گئی ❤️',
          'میری دنیا تم ہو ❤️',
          'تجھ میں رب دکھتا ہے ❤️',
          'توم ہی ہو، اب تم ہی ہو ❤️',
      'ایک ہزاروں میں میری بہنا ہے ❤️',
      'تیرے جیسے یار کہاں ❤️',
      'تو میری بہن، تو میری جان ❤️',
      'زندگی کا ہر لمحہ، تیرے نام ❤️',
      'یہ پیارا رشتہ، دل سے جڑا ہے ❤️'
      
      
        ],
        x : 0,
        y : 500,
        fontSize : 120,
        fontColor : "white"
    };
const captionDropdown = document.getElementById('caption-dropdown');


// Function to populate select options from list
function populateSelectOptions(list) {
            list.forEach((option, index) => {
                // Create a new option element
                const newOption = document.createElement('option');
                newOption.text = option;
                newOption.value = index+1; // Set custom value like "option1", "option2", etc.

                // Append the new option to the select element
                captionDropdown.appendChild(newOption);
            });
}
 // Call the function to populate options from list
populateSelectOptions(caption.text);



    const canvasColor = 'black';
    
    const ctx = canvas.getContext('2d');
    const ctx2 = canvasForPrint.getContext('2d');

    // Preload the heart image
    const frameImg = new Image();
    frameImg.onload = function() 
    {
    frameImg.crossOrigin = 'anonymous'; // Enable CORS

         ctx.drawImage(frameImg, 0, 0, 2100, 2970);
                        // Call the function to draw the calendar once the image is loaded
    };
    frameImg.src = 'https://cdn.shopify.com/s/files/1/0663/5546/2307/files/frame-101.png?v=1722753002'; // Replace 'heart.png' with the URL of your heart image



    // Preload the heart image
    const heartImg = new Image();
    heartImg.onload = function() 
    {
    heartImg.crossOrigin = 'anonymous'; // Enable CORS

        //  ctx.drawImage(heartImg, 180, 2350, 810, 240);
                        // Call the function to draw the calendar once the image is loaded
    };
    heartImg.src = 'https://cdn.shopify.com/s/files/1/0586/0137/3805/files/cpin-black.jpg?v=1721030002'; // Replace 'heart.png' with the URL of your heart image

// Preload the mene tera nam dil rkh dia
const captionImg1 = new Image();
    captionImg1.onload = function() {
        captionImg1.crossOrigin = 'anonymous'; // Enable CORS

    };
    captionImg1.src = 'https://cdn.shopify.com/s/files/1/0586/0137/3805/files/caption1-black.jpg?v=1721029579'; // Replace 'caption-white' with the URL of your required caption image



     //canvas background
     ctx.fillStyle = "black";
     ctx2.fillStyle = "black";

    ctx.fillRect(0,0,canvas.width,canvas.height);
    ctx2.fillRect(0,0,canvasForPrint.width,canvasForPrint.height);

 
    //frame background
    ctx.fillStyle = "black";
    ctx2.fillStyle = "black";

    ctx.fillRect(33,310,2030,2350);
    ctx2.fillRect(33,310,2030,2350);

    //Callender Area
    ctx.fillStyle = "grey";
    ctx2.fillStyle = "grey";

    ctx.fillRect(675,2020,730,550);

 
        //Image 1
    ctx.fillStyle = "grey";
    ctx.fillRect(2100/2-1800/2,700,1800,1225);
   

           //text above 1
    ctx.fillStyle = "grey";
    ctx.fillRect(35,350,2025,200);
 
 

    const downloadButton = document.getElementById('download-button');

    // Function to handle image upload and drawing
    function handleImageUpload(event, x, y, width, height) {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = function(e) {
            // Get the button element by its id
            const uploadButton = document.getElementById('image-upload-1');
            // Change the background color of the button
            uploadButton.style.backgroundColor = '#007bff'; // Blue color
            uploadButton.style.color = '#fff'; // White text color
          
            const uploadedImage = new Image();
            uploadedImage.onload = function() {
                // ctx.drawImage(uploadedImage, x, y, width, height);
                
                drawImageProp(ctx, uploadedImage, x, y, width, height);
                drawImageProp(ctx2, uploadedImage, x, y, width, height);

            };
            uploadedImage.src = e.target.result;
        };

        reader.readAsDataURL(file);
    }

    const uploadButton = document.getElementById('image-upload-1');

// Add an event listener to the button to change its color when clicked
uploadButton.addEventListener('click', function() {
    // Change the background color of the button
    uploadButton.style.backgroundColor = '#007bff'; // Blue color
    uploadButton.style.color = '#fff'; // White text color
});

/**
 * By Ken Fyrstenberg Nilsen
 *
 * drawImageProp(context, image [, x, y, width, height [,offsetX, offsetY]])
 *
 * If image and context are only arguments rectangle will equal canvas
*/
function drawImageProp(ctx, img, x, y, w, h, offsetX, offsetY) {

if (arguments.length === 2) {
    x = y = 0;
    w = ctx.canvas.width;
    h = ctx.canvas.height;
}

// default offset is center
offsetX = typeof offsetX === "number" ? offsetX : 0.5;
offsetY = typeof offsetY === "number" ? offsetY : 0.5;

// keep bounds [0.0, 1.0]
if (offsetX < 0) offsetX = 0;
if (offsetY < 0) offsetY = 0;
if (offsetX > 1) offsetX = 1;
if (offsetY > 1) offsetY = 1;

var iw = img.width,
    ih = img.height,
    r = Math.min(w / iw, h / ih),
    nw = iw * r,   // new prop. width
    nh = ih * r,   // new prop. height
    cx, cy, cw, ch, ar = 1;

// decide which gap to fill    
if (nw < w) ar = w / nw;                             
if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh;  // updated
nw *= ar;
nh *= ar;

// calc source rectangle
cw = iw / (nw / w);
ch = ih / (nh / h);

cx = (iw - cw) * offsetX;
cy = (ih - ch) * offsetY;

// make sure source rectangle is valid
if (cx < 0) cx = 0;
if (cy < 0) cy = 0;
if (cw > iw) cw = iw;
if (ch > ih) ch = ih;

// fill image in dest. rectangle
ctx.drawImage(img, cx, cy, cw, ch,  x, y, w, h);

refreshTheCanvas();
}
function refreshTheCanvas(){
    ctx.drawImage(frameImg, 0, 0, 2100, 2970);

}

function generateCalendar() {

      // clear Callender Area
    ctx.fillStyle = "black";
    ctx2.fillStyle = "black";

    ctx.fillRect(600,1950,830,700);
    ctx2.fillRect(600,1950,830,700);

        const dobInput = document.getElementById('dob-input');
        const dobDate = new Date(dobInput.value);
        
        if (isNaN(dobDate.getTime())) {
            alert('Please enter a valid date of birth.');
            return;
        }
        
        const year = dobDate.getFullYear();
        const month = dobDate.getMonth();
        
        const firstDayOfMonth = new Date(year, month, 1);
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const startingDay = firstDayOfMonth.getDay(); // 0 is Sunday, 1 is Monday, etc.
        // 140,460,830,550
        const cellSize = 100;
        const xOffset = 725;
        const yOffset = 2075;

        // ctx.clearRect(0, 0, canvas.width, canvas.height);

        // Draw calendar header
        ctx.fillStyle = '#fff';
        ctx2.fillStyle = '#fff';

        ctx.font = 'bold 48px Arial';
        ctx2.font = 'bold 48px Arial';

        ctx.fillText(firstDayOfMonth.toLocaleString('default', { month: 'short' }) + ' ' + year, xOffset+230, yOffset-50);
        ctx2.fillText(firstDayOfMonth.toLocaleString('default', { month: 'short' }) + ' ' + year, xOffset+230, yOffset-50);


        // Draw day labels
        const dayLabels = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        ctx.font = 'bold 28px Arial';
        ctx2.font = 'bold 28px Arial';

        for (let i = 0; i < dayLabels.length; i++) {
            ctx.fillText(dayLabels[i], xOffset + i * cellSize, yOffset+10);
            ctx2.fillText(dayLabels[i], xOffset + i * cellSize, yOffset+10);

        }

        // Draw calendar cells
        let x = xOffset + (startingDay * cellSize);
        let y = yOffset + cellSize;

        ctx.font = '32px Arial';
        ctx2.font = '32px Arial';

        for (let i = 1; i <= daysInMonth; i++) {
            ctx.fillText(i, x, y);
            ctx2.fillText(i, x, y);

            // Draw heart on birth date
            if (i === dobDate.getDate()) {
                ctx.drawImage(heartImg, x-20, y-40, cellSize-30, cellSize-30);
                ctx2.drawImage(heartImg, x-20, y-40, cellSize-30, cellSize-30);


            } 
                x += cellSize;
            if (x >= xOffset + 7 * cellSize) {
                x = xOffset;
                y += cellSize-20;
                
            }
            


            
        }
        refreshTheCanvas();
    }



    // Event listeners for image 1 upload
    const imageUploads = document.querySelectorAll('#image-upload-1');
    imageUploads.forEach((upload, index) => {
        upload.addEventListener('change', function(event) {
            // Define the coordinates and dimensions for each image area here
            // Example: For image 1
            const x = 148; // X-coordinate
            const y = 698; // Y-coordinate
            const width = 1803; // Width
            const height = 1230; // Height
            handleImageUpload(event, x, y, width, height);
        });
    });

   

    // // Function to download canvas as image
    // function downloadCanvas() {
    //     const link = document.createElement('a');
    //     link.download = 'canvas_image.jpg';
    //     link.href = canvas.toDataURL('image/jpeg');
    //     link.click();
    // }
   // Function to download canvas as image
    function downloadCanvas() {
       window.open("https://diwar.pk/collections/wooden-frame-on-diwar-pk-new-creative-designs-collection");
    }
 
    // Event listener for download button
    downloadButton.addEventListener('click', downloadCanvas);
    


// option shift change
    function showText() {
    const dropdown = document.getElementById('caption-dropdown');
    const displayText = document.getElementById('display-text');

    switch (dropdown.value) {
        case '1':
            writeTextInUrdu(caption.text[0], caption.x,caption.y, caption.fontSize, caption.fontColor);    
              break;
        case '2':
            writeTextInUrdu(caption.text[1], caption.x,caption.y, caption.fontSize, caption.fontColor);
            break;
       case '3':
            writeTextInUrdu(caption.text[2], caption.x,caption.y, caption.fontSize, caption.fontColor);
            break;
       case '4':
            writeTextInUrdu(caption.text[3], caption.x,caption.y, caption.fontSize, caption.fontColor);
            break;
       case '5':
            writeTextInUrdu(caption.text[4], caption.x,caption.y, caption.fontSize, caption.fontColor);
            break;
       case '6':
            writeTextInUrdu(caption.text[5], caption.x,caption.y, caption.fontSize, caption.fontColor);
            break;
       case '7':
            writeTextInUrdu(caption.text[6], caption.x,caption.y, caption.fontSize, caption.fontColor);
            break;
       case '8':
            writeTextInUrdu(caption.text[7], caption.x,caption.y, caption.fontSize, caption.fontColor);
            break;
       case '9':
            writeTextInUrdu(caption.text[8], caption.x,caption.y, caption.fontSize, caption.fontColor);
            break;
       case '10':
            writeTextInUrdu(caption.text[9], caption.x,caption.y, caption.fontSize, caption.fontColor);
            break;
       case '11':
            writeTextInUrdu(caption.text[10], caption.x,caption.y, caption.fontSize, caption.fontColor);
            break;
       case '12':
            writeTextInUrdu(caption.text[11], caption.x,caption.y, caption.fontSize, caption.fontColor);
            break;
       case '13':
            writeTextInUrdu(caption.text[12], caption.x,caption.y, caption.fontSize, caption.fontColor);
            break;
      
        default:
    }
}


function writeTextInUrdu(text, x, y, size, color){
   
   ctx.fillStyle = canvasColor;
   ctx2.fillStyle = canvasColor;
  
 ctx.fillRect(35,350,2025,200);
 ctx2.fillRect(35,350,2025,200);
  
 // Set the font properties
 console.log("This is a log");
 ctx.font = size+'px Arial'; // Use a font that supports Urdu
 ctx2.font = size+'px Arial'; // Use a font that supports Urdu

 ctx.textAlign = 'right'; // Align text to the right
 ctx2.textAlign = 'right'; // Align text to the right

 ctx.direction = 'rtl'; // Set text direction to right-to-left
 ctx2.direction = 'rtl'; // Set text direction to right-to-left
 ctx.fillStyle = 'white'; // Set text color
 ctx2.fillStyle = 'white'; // Set text color
// Draw the Urdu text
 ctx.fillText(text, 2100/2+ctx.measureText(text).width/2, caption.y);
 ctx2.fillText(text, 2100/2+ctx.measureText(text).width/2, caption.y);


 // Set the font properties for English text
     ctx.font = '30px Arial';
     ctx2.font = '30px Arial';
     ctx.textAlign = 'left';
     ctx2.textAlign = 'left';
     ctx.direction = 'ltr';
     ctx2.direction = 'ltr';
     refreshTheCanvas();
}

